export const defaultRowsNum = 12;
export const fetchMax = 0;
export const maxPinnedColumns = 5;
export const rowHeight = 26;
export const headerHeight = 36;
export const defaultHeight = 362;

export enum subFormNavDirections {
    right = 'right',
    left = 'left'
}

export const defaultGridMinHeight = 209; 